import Repository from "./Repository";

const WITHDRAW = "/withdraw";
export default {
  setWithdraw(payload) {
    return Repository.post(`${WITHDRAW}`, payload);
  },
};
